import { render, staticRenderFns } from "./box5.vue?vue&type=template&id=04f15ced&scoped=true&"
import script from "./box5.vue?vue&type=script&lang=js&"
export * from "./box5.vue?vue&type=script&lang=js&"
import style0 from "./box5.vue?vue&type=style&index=0&id=04f15ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f15ced",
  null
  
)

export default component.exports